/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Quick_Workout_SwappedInputs */

const en_us2_quick_workout_swapped = /** @type {(inputs: Quick_Workout_SwappedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Swapped for today: ${i?.name}`)
};

const pt_br2_quick_workout_swapped = /** @type {(inputs: Quick_Workout_SwappedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Trocado só hoje: ${i?.name}`)
};

const es_419_quick_workout_swapped = /** @type {(inputs: Quick_Workout_SwappedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Cambiado solo por hoy: ${i?.name}`)
};

const pt_pt2_quick_workout_swapped = /** @type {(inputs: Quick_Workout_SwappedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Trocado só hoje: ${i?.name}`)
};

const fr_fr2_quick_workout_swapped = /** @type {(inputs: Quick_Workout_SwappedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Remplacé pour aujourd'hui : ${i?.name}`)
};

const de_de2_quick_workout_swapped = /** @type {(inputs: Quick_Workout_SwappedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Nur heute getauscht: ${i?.name}`)
};

const it_it2_quick_workout_swapped = /** @type {(inputs: Quick_Workout_SwappedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Cambiato solo per oggi: ${i?.name}`)
};

/**
* | output |
* | --- |
* | "Swapped for today: {name}" |
*
* @param {Quick_Workout_SwappedInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const quick_workout_swapped = /** @type {((inputs: Quick_Workout_SwappedInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Quick_Workout_SwappedInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_quick_workout_swapped(inputs)
	if (locale === "es-419") return es_419_quick_workout_swapped(inputs)
	if (locale === "pt-PT") return pt_pt2_quick_workout_swapped(inputs)
	if (locale === "fr-FR") return fr_fr2_quick_workout_swapped(inputs)
	if (locale === "de-DE") return de_de2_quick_workout_swapped(inputs)
	if (locale === "it-IT") return it_it2_quick_workout_swapped(inputs)
	return en_us2_quick_workout_swapped(inputs)
});
export { quick_workout_swapped as "quick-workout.swapped" }